export const getDescription = (Dropdown,id) => {
    if(id =="")  return "";
    const descriptionRow = Dropdown.filter(row =>row.uniqueId == id);
    if(descriptionRow.length > 0 && descriptionRow[0].description)  {
        return descriptionRow[0].description;
    }
    return "";
}